<template>
  <section>
    <TableListing :items="items" :fields="fieldsAll" :showPaginationRow="true" :pagination.sync="pagination" :options.sync="tableOptions">
      <template v-slot:cell(quantity)="data">
        <span>{{ parseFloat(data.item.quantity).toFixed(2) }}</span>
      </template>
      <template v-slot:cell(wholesalePrice)="data">
        <span>${{ parseFloat(data.item.wholesalePrice).toFixed(2) }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'FactoringFinanceInvoiceReport-view',
  components: {
    TableListing: TableListing
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      myProjs: 'getMyProjects',
      countryCodeList: 'getCountryCodeList',
      USAStateCodeList: 'getUSAStateCodeList'
    })
  },
  methods: {
  },
  mounted() {
    this.tableOptions.totalRows = this.items.length;
  },
  data() {
    return {
      pagination: {
        sortBy: '',
        sortDesc: false,
        perPage: 10,
        page: 1
      },
      tableOptions: {
        totalRows: 10,
        loadedAll: true
      },
      fieldsAll: [
        { key: 'sku', label: 'Item', sortable: false },
        { key: 'name', label: 'Client', sortable: false },
        //{ key: 'ledgerEntryType', label: 'Ledger Type', sortable: false },
        { key: 'quantity', label: 'Qty', sortable: false },
        { key: 'wholesalePrice', label: 'Wholesale Price', sortable: false },
        { key: 'amount', label: 'Total', sortable: false }
      ],
    }
  }
}
</script>

<style>

</style>
